import React from "react";
import RFField from "../../../components/Form/RFField";
import { DatePicker } from "../../../commons/controls";
import { Button } from "reactstrap";
import { useRFFormContext } from "../../../components/Form/RFForm";

const PartnertorzsUrlapHozzajarulasList = ({
  isMaganszemely,
  jogalap,
  cegadat,
  hozzajarulas,
  getRequired,
  modositoObj,
  onJogalapChange,
  onCegadatChange,
  onDateChange,
  onDateVegeChange,
  disabledHozzajarulasIds,
  onVisszavonPdfBtnClick,
  onDelete,
}) => {
  const { change } = useRFFormContext();
  const editFieldsVisible = modositoObj && modositoObj.length !== 0;

  return (
    <div
      className="d-flex flex-column gap-3"
      style={{ marginBottom: "16px", paddingLeft: "16px" }}
    >
      <div
        className="row align-items-flex-end"
        style={{ marginBottom: "-8px" }}
      >
        <div className="col-md-3">
          {getRequired("m_gdpr") ? "Jogalap: *" : "Jogalap: "}
        </div>
        <div className="col-md-3">
          {getRequired("m_gdpr") ? "Kiállító: *" : "Kiállító: "}
        </div>
        <div className="col-md-2">
          {getRequired("m_gdpr") ? "Kezdete: *" : "Kezdete: "}
        </div>
        {editFieldsVisible && hozzajarulas.some((x) => !!x.id) && (
          <div className="col-md-2">Vége:</div>
        )}
      </div>

      {hozzajarulas.map((item, idx) => (
        <div className="row align-items-center" key={item.uuid}>
          <div className="col-md-3" id="jogalaplabel">
            <RFField
              type="select"
              name={"jogalap" + item.uuid}
              id={"jogalap" + item.uuid}
              onChange={(e, v) => {
                onJogalapChange(e, v, idx);
              }}
              value={item.jogalapid != "-1" ? item.jogalapid : ""}
              disabled={item.id ? true : false}
              required={isMaganszemely ? getRequired("m_gdpr") : false}
              defaultSelect={!item.id && <option value="">Válassz jogalapot...</option>}
              selectOptions={jogalap && jogalap.filter(x => !item.id && x.statusz === 'AKTIV' || x.id === item.jogalapid).map(e => (
                <option key={e.id} value={e.id}>
                  {e.nev}
                </option>
              ))}
              selectContainerStyles={{ marginBottom: 0 }}
              style={{ height: "38px" }}
              hideErrorMessage
            />
          </div>
          <br />
          <div className="col-md-3">
            <RFField
              type="select"
              name={"cegadat" + item.uuid}
              id={"cegadat" + item.uuid}
              onChange={(e, v) => onCegadatChange(e, v, idx)}
              value={item.cegadatid !== "" ? item.cegadatid : "-1"}
              disabled={item.id ? true : false}
              required={isMaganszemely ? getRequired("m_gdpr") : false}
              defaultSelect={!item.id && <option disabled value="">Válassz cégadatot...</option>}
              selectOptions={cegadat && cegadat.filter(x => !item.id && x.aktiv || x.id === item.cegadatid).map(e => (
                <option key={e.id} value={e.id}>
                  {e.nev + ' (' + e.tipus + ')'}
                </option>
              ))}
              selectContainerStyles={{ marginBottom: 0 }}
              style={{ height: "38px" }}
              hideErrorMessage
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              placeholder="éééé-hh-nn"
              name={"kezdete" + item.uuid}
              value={
                (modositoObj || item.kezdete !== "") && item.kezdete !== ""
                  ? new Date(item.kezdete)
                  : new Date()
              }
              disabled={item.id ? true : false}
              required={isMaganszemely ? getRequired("m_gdpr") : false}
              onChange={(e, v) => onDateChange(e, v, idx)}
              style={{ marginBottom: 0 }}
            />
          </div>

          {editFieldsVisible && item.id ? (
            <>
              <div className="col-md-2">
                <DatePicker
                  required
                  name={"vege" + item.uuid}
                  placeholder="éééé-hh-nn"
                  value={modositoObj && item.vege && new Date(item.vege)}
                  disabled={disabledHozzajarulasIds.includes(item.id)}
                  onChange={(e, v) => onDateVegeChange(e, v, idx)}
                  style={{ marginBottom: 0 }}
                />
              </div>
              <div className="col-md-2">
                <Button
                  color="primary"
                  style={{ height: "38px" }}
                  type="button"
                  onClick={() => onVisszavonPdfBtnClick(idx)}
                >
                  PDF
                </Button>
              </div>
            </>
          ) : (
            <div className="col-md-3">
              <Button
                color="danger"
                style={{ height: "38px" }}
                type="button"
                onClick={() => {
                  change("jogalap" + item.uuid, null);
                  change("cegadat" + item.uuid, null);
                  change("kezdete" + item.uuid, null);
                  change("vege" + item.uuid, null);
                  onDelete(idx);
                }}
              >
                Törlés
              </Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PartnertorzsUrlapHozzajarulasList;
